module.exports = __webpack_public_path__ + "img/benoit26.9366a65f.jpg";